import { render, staticRenderFns } from "./InputSelectTags.vue?vue&type=template&id=4aec6a11&scoped=true&"
import script from "./InputSelectTags.vue?vue&type=script&lang=js&"
export * from "./InputSelectTags.vue?vue&type=script&lang=js&"
import style0 from "./InputSelectTags.vue?vue&type=style&index=0&id=4aec6a11&prod&lang=scss&"
import style1 from "./InputSelectTags.vue?vue&type=style&index=1&id=4aec6a11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aec6a11",
  null
  
)

export default component.exports